import React, { createContext, useState, useMemo } from "react";

export type FindifyMenuContextType = {
    isSidemenuOpen: boolean;
    setIsSidemenuOpen: (isOpen: boolean) => void;
    isSidemenu: boolean;
    setIsSidemenu: (isSidemenu: boolean) => void;
}

export const FindifyMenuContext = createContext<FindifyMenuContextType | null>(null);

export const FindifyMenuProvider = ({ children }: { children: React.ReactNode }) => {
    const [isSidemenuOpen, setIsSidemenuOpen] = useState(false);
    const [isSidemenu, setIsSidemenu] = useState(false);

    const value = useMemo(() => ({
        isSidemenuOpen,
        setIsSidemenuOpen,
        isSidemenu,
        setIsSidemenu
    }), [isSidemenuOpen, isSidemenu]);

    return (
        <FindifyMenuContext.Provider value={value}>
            {children}
        </FindifyMenuContext.Provider>
    );
};